import { auto, Izlude, masterape, masterChefGenABI, MiniChef, swamp, tenfinance } from '@jdiyield/abi'
import {
  ALPHA,
  APEZONE_POOLS,
  AUTO,
  AUTO_CAKE_POOL,
  AUTO_CC,
  AUTO_POLYGON,
  BAKERYSWAP,
  BEEFY,
  BUNNY,
  ChainID,
  COPYCAT_LP,
  DFYN_POOLS,
  FIFTYCENT_POOLS,
  FIREBIRD_FARM_HOPE,
  FIREBIRD_FARM_HOPE_POLYGON,
  HORIZON,
  IRON_V2,
  JOE,
  KILLSWITCH_VAULT,
  LATTE_SWAP,
  MOON_POTS,
  PANGOLIN,
  POLYCAT_POOL,
  POLYCRYSTAL_AUTO_POOL,
  POLYCRYSTAL_PARTNER_POOLS,
  POLYYELD_AUTO_POOL,
  QUICK_POOLS,
  SEEDER_POOL,
  SWAMP,
  SYRUP_POOLS,
  TENFINANCE
} from '@jdiyield/constants'
import { Chain, Platform, PlatformName, PriceList, Stake, Token } from '@jdiyield/interfaces'
import throat from 'throat'
import Web3 from 'web3'

import autofarmCCABI from './abi/autofarmCC.json'
import UniswapV2PairABI from './abi/UniswapV2Pair.json'
import { calculate } from './calculate'
import { getJDIVault } from './features/jdiAuto'
import { get50CentFarm } from './platforms/50cent'
import { getAleswapVault } from './platforms/aleswapVault'
// import { getAlpha } from './platforms/alpha'
import { getFarmsApeRocket } from './platforms/aperocket'
import { getApeZonePool } from './platforms/apezone'
import { getAutoPoolCake } from './platforms/autoCake'
import { getAxieLockReward } from './platforms/axies'
import { getBakerySwap } from './platforms/Bakery'
import { getBalancerReward } from './platforms/balancer'
import { getBeefy } from './platforms/beefy'
import { getCommunityRewardPool } from './platforms/communityReward'
import { getCopycat } from './platforms/copycat'
import { getDinoparkPoolLV1 } from './platforms/dinopark/dinoparkPool'
import { getFirebird } from './platforms/firebird'
import { getJOE } from './platforms/joe'
import { getLatteSwap } from './platforms/latteswap'
import { getMoonPots } from './platforms/moonpots'
// import { getStakingHorizon } from './platforms/horizon'
import { getFarmsPancakeBunny } from './platforms/pancakeBunny'
import { getPangolinFarm } from './platforms/pangolin'
import { getPolyCatFarm } from './platforms/polycat'
import { getQuickSwapFarm } from './platforms/quick'
import { getSeederFarm } from './platforms/seeder'
import { getSyrupPool } from './platforms/syrupPool'
import { getPoolAutoNoReward } from './poolType/autoNoReward'
import { getMiniChefFarm } from './poolType/miniChef'
import getNodeUrl from './rpcRandom'
import { findToken, makeBatchRequest, makeBatchRequestIncludeError } from './utils'

type Props = {
  web3?: Web3
  chainID: ChainID
  account: string
  platform: Platform
  tokens: Token[]
  priceList?: PriceList
}

export const queryFarm = async ({
  web3: web3Prop,
  chainID,
  account,
  platform,
  tokens,
  priceList
}: Props): Promise<(Stake | null)[]> => {
  const { contracts } = platform
  if (!account) return null
  if (!contracts || contracts.length === 0) return null
  if (Object.keys(priceList).length === 0) return null
  //? UNIQUE FETCH BINANCE SMART CHAIN

  try {
    // const provider = new Web3.providers.HttpProvider(, {
    //   timeout: 120000
    // })
    const web3 = web3Prop || new Web3(getNodeUrl(chainID))
    const result = await Promise.all(
      contracts.flatMap(async (ct) => {
        const { contractAddress, routerAddress, pendingReward, rewardAddress, showReward } = ct
        try {
          switch (platform.name) {
            case PlatformName.AXIE_INFINITY:
              return await getAxieLockReward(account, ct, tokens, priceList)
            case PlatformName.DINOP:
              return await getDinoparkPoolLV1(account, ct, tokens, priceList, web3Prop)

            case PlatformName.SUSHISWAP_POLYGON:
              return await getMiniChefFarm(account, ct, tokens, priceList, web3Prop)

            case PlatformName.JDI: {
              const result = await getJDIVault(web3, account, ct, tokens, priceList, Chain.BINANCE_SMART_CHAIN)
              return result.map((obj) => ({ ...obj, ...ct }))
            }

            case PlatformName.JDI_POLYGON: {
              const result = await getJDIVault(web3, account, ct, tokens, priceList, Chain.POLYGON)
              return result.map((obj) => ({ ...obj, ...ct }))
            }

            case PlatformName.BEEFY: {
              const result = await getBeefy(web3, account, routerAddress, tokens, priceList, 56)
              return result.map((obj) => ({ ...obj, ...ct }))
            }
            case PlatformName.BEEFY_POLYGON: {
              const result = await getBeefy(web3, account, routerAddress, tokens, priceList, 137)
              return result.map((obj) => ({ ...obj, ...ct }))
            }
            case PlatformName.BALANCER_POLYGON:
            case PlatformName.BALANCER_ETH: {
              return await getBalancerReward(account, ct, tokens, priceList, chainID)
            }
            case PlatformName.ALESWAP_VAULT: {
              return await getAleswapVault(account, ct, tokens, priceList, web3Prop)
            }
            default:
              break
          }

          switch (contractAddress) {
            //? BSC
            case SEEDER_POOL:
              return await getSeederFarm(account, ct, tokens, priceList, web3Prop)
            // case ALPHA: {
            //   const result = await getAlpha(account, tokens)
            //   return [
            //     {
            //       ...ct,
            //       ...result
            //     }
            //   ] as Stake[]
            // }

            case BUNNY: {
              const result = await getFarmsPancakeBunny(web3, account, tokens, priceList)
              return result.map((obj) => ({ ...obj, ...ct }))
            }
            // case MERLINLAB:
            //   return await getFarmsMerlinLab(account, tokens, priceList, web3Prop)
            // case HORIZON:
            //   return await getStakingHorizon(account, tokens, priceList)
            case AUTO_CAKE_POOL: {
              const result = await getAutoPoolCake(account, priceList, web3Prop)
              return [
                {
                  ...result,
                  ...ct
                }
              ] as Stake[]
            }
            case BAKERYSWAP: {
              const result = await getBakerySwap(account, ct, priceList, web3Prop, tokens)

              return { ...result, ...ct }
            }
            case '0xf1cF07Fe21b7dC6cf8b196Fe978ec94ed0c106a5':
            case '0x0080e040020892e87677148cbc28a09b2d3bf86e':
              return await getCommunityRewardPool(account, ct, tokens, priceList, 56, null, web3Prop)
            //? POLYGON
            case FIREBIRD_FARM_HOPE:
              return await getFirebird(account, ct, tokens, priceList, web3Prop)
            case FIREBIRD_FARM_HOPE_POLYGON:
              return await getFirebird(account, ct, tokens, priceList, web3Prop)
            case IRON_V2:
              return await getMiniChefFarm(account, ct, tokens, priceList, web3Prop)
            case POLYCAT_POOL:
              return await getPolyCatFarm(account, ct, tokens, priceList, web3Prop)

            default:
              break
          }
          if (PANGOLIN.includes(contractAddress)) {
            return await getPangolinFarm(account, ct, tokens, priceList, web3Prop)
          }
          if (JOE.includes(contractAddress)) {
            return await getJOE(account, ct, tokens, priceList, web3Prop)
          }
          if (MOON_POTS.includes(contractAddress)) {
            return await getMoonPots(account, ct, tokens, priceList, web3Prop)
          }

          if (COPYCAT_LP.includes(contractAddress)) {
            return await getCopycat(account, ct, tokens, priceList, web3Prop)
          }

          if (SYRUP_POOLS.includes(contractAddress)) {
            return await getSyrupPool(account, ct, tokens, priceList, 56, web3Prop)
          }

          if (platform.name === PlatformName.APE_ROCKET || platform.name === PlatformName.APE_ROCKET_POLYGON) {
            return await getFarmsApeRocket(account, ct, chainID, tokens, priceList, web3Prop)
          }

          if (POLYCRYSTAL_PARTNER_POOLS.includes(contractAddress)) {
            return await getCommunityRewardPool(account, ct, tokens, priceList, 137, '0', web3Prop)
          }

          if (FIFTYCENT_POOLS.includes(contractAddress)) {
            return await get50CentFarm(account, ct, tokens, priceList, web3Prop)
          }

          if ([...QUICK_POOLS, ...DFYN_POOLS].includes(contractAddress)) {
            return await getQuickSwapFarm(account, ct, tokens, priceList, web3Prop)
          }
          if (APEZONE_POOLS.includes(contractAddress)) {
            return await getApeZonePool(account, ct, tokens, priceList, web3Prop)
          }

          if ([POLYYELD_AUTO_POOL, POLYCRYSTAL_AUTO_POOL].includes(contractAddress)) {
            return await getPoolAutoNoReward(account, ct, tokens, priceList, 137, web3Prop)
          }

          if (LATTE_SWAP === contractAddress) {
            return await getLatteSwap(account, ct, tokens, priceList, web3Prop)
          }

          const contract = new web3.eth.Contract(masterape as any, contractAddress)
          const _poolLength = await contract.methods
            .poolLength()
            .call()
            .catch(() => 1)
          const poolArray = [...Array(parseInt(_poolLength))]

          let _userInfoResults = []

          if (contractAddress === AUTO_CC) {
            const autoCCContract = new web3.eth.Contract(autofarmCCABI as any, contractAddress)
            _userInfoResults = await Promise.all(
              poolArray.map(async (_data, poolId) => {
                if (poolId) {
                  try {
                    const result = await autoCCContract.methods.stakedWantTokens(poolId, account).call()
                    return result || '0'
                  } catch (e) {
                    return '0'
                  }
                } else {
                  return '0'
                }
              })
            )
          } else if ([AUTO, AUTO_POLYGON].includes(contractAddress)) {
            const autoContract = new web3.eth.Contract(auto as any, contractAddress)
            _userInfoResults = await Promise.all(
              poolArray.map(async (_data, poolId) => {
                if (poolId) {
                  try {
                    const result = await autoContract.methods.stakedWantTokens(poolId, account).call()
                    return result || '0'
                  } catch (e) {
                    return '0'
                  }
                } else {
                  return '0'
                }
              })
            )
          } else {
            _userInfoResults = await makeBatchRequest(
              web3,
              poolArray.map((_data, poolId) => {
                if (contractAddress == SWAMP) {
                  const swampContract = new web3.eth.Contract(swamp as any, contractAddress)
                  return swampContract.methods.stakedWantTokens(poolId, account).call
                } else if (contractAddress == TENFINANCE) {
                  const tenFinanceContract = new web3.eth.Contract(tenfinance as any, contractAddress)
                  return tenFinanceContract.methods.stakedWantTokens(poolId, account).call
                } else {
                  return contract.methods.userInfo(poolId, account).call
                }
              })
            )
          }
          const _balances = _userInfoResults.map((result, poolId) => {
            let balance = '0' as any
            if ([AUTO, AUTO_POLYGON, AUTO_CC, SWAMP, TENFINANCE].includes(contractAddress)) {
              balance = result === '0' ? '0' : result
            } else {
              balance = result['0']
            }
            return { pool: poolId, balance: balance || 0 }
          })
          // .filter((b) => +b.balance > 1000)
          const poolWhiteList = _balances.filter(({ balance }) => +balance > 0).map(({ pool }) => pool)
          const filteredBalance = _balances.filter(({ pool }) => poolWhiteList.includes(pool))

          if (filteredBalance.length === 0) return []
          let _balancesLP = await makeBatchRequest(
            web3,
            filteredBalance.map((b) => {
              if (contractAddress === '0x54aff400858Dcac39797a81894D9920f16972D1D') {
                const miniApeContract = new web3.eth.Contract(MiniChef as any, contractAddress)
                return miniApeContract.methods.lpToken(b.pool).call
              }
              return contract.methods.poolInfo(b.pool).call
            })
          )
          if (contractAddress === KILLSWITCH_VAULT) {
            _balancesLP = await makeBatchRequest(
              web3,
              _balancesLP.map(({ '0': vaultAddress }) => {
                const kswContract = new web3.eth.Contract(Izlude as any, vaultAddress)
                return kswContract.methods.want().call
              })
            )
          }

          const _balancesLPResult = _balancesLP.map((obj, i) => {
            const lpAddress = typeof obj === 'string' ? obj : obj?.['lpToken'] || obj?.['0']
            return {
              ...filteredBalance[i],
              lpAddress
            }
          })

          const _balanceLPPair = _balancesLPResult.map(
            throat(80, async (lp: any) => {
              return calculate(
                web3,
                {
                  ...lp,
                  rewardAddress
                },
                routerAddress,
                tokens,
                priceList,
                chainID
              )
            })
          )

          const _pendingReward = async () => {
            if (!showReward) return []
            try {
              const contract = new web3.eth.Contract(masterChefGenABI({ pendingReward }), contractAddress)
              const result = await makeBatchRequest(
                web3,
                _balancesLPResult
                  .filter(({ pool }) => poolWhiteList.includes(pool))
                  .map((lp) => {
                    return contract.methods[`${pendingReward}`](lp.pool, account).call
                  })
              )
              return result.map((reward, index) => ({ ..._balancesLPResult[index], reward }))
            } catch (error) {
              console.log(_balancesLPResult, error)
              return _balancesLPResult.map((lp) => ({ ...lp, reward: 0 }))
            }
          }

          const [completeBalance, completePendingReward] = await Promise.all([
            Promise.all(_balanceLPPair),
            _pendingReward()
          ])
          const rewardSymbol = findToken(tokens, rewardAddress)?.symbol ?? '???'
          const rewardPrice = priceList[rewardAddress]?.usd || 0
          const result = completeBalance
            .filter((obj) => obj !== null)
            .map((i) => {
              const reward = completePendingReward.find((a: any) => a.pool === i.pool)?.reward / 1e18 || 0
              return {
                ...i,
                ...ct,
                availableBalanceOf: '0',
                reward,
                rewardSymbol,
                rewardUSD: reward * rewardPrice
              } as Stake
            })
          return result
        } catch (e) {
          console.log(contractAddress, e)
          return null
        }
      })
    )
    const endResult = await result.flat().filter((ob) => ob !== null)
    return endResult
  } catch (error) {
    console.log(error)
    return []
  }
}

export const queryAvailableBalanceOf = async ({
  chainID,
  walletAddress,
  lpAddresses
}: {
  chainID: ChainID
  walletAddress: string
  lpAddresses: string[]
}): Promise<string[]> => {
  const web3 = new Web3(getNodeUrl(chainID))

  const availableBalances = await makeBatchRequestIncludeError(
    web3,
    lpAddresses.map((address: string) => {
      const contract = new web3.eth.Contract(UniswapV2PairABI as any, address)
      return contract.methods.balanceOf(walletAddress).call
    })
  )

  return availableBalances
}
